export const UPDATE_USER = 'UPDATE_USER'

// student
export const RGST_STDT = 'RGST_STDT'
export const RGST_STDT_FAILED = 'RGST_STDT_FAILED'
export const RGST_STDT_OK = 'RGST_STDT_OK'

export const GET_STDT_INFO = 'GET_STDT_INFO'
export const GET_STDT_INFO_FAILED = 'GET_STDT_INFO_FAILED'
export const GET_STDT_INFO_OK = 'GET_STDT_INFO_OK'

export const GET_STDT_CREDIT = 'GET_STDT_CREDIT'
export const GET_STDT_CREDIT_FAILED = 'GET_STDT_CREDIT_FAILED'
export const GET_STDT_CREDIT_OK = 'GET_STDT_ACREDIT_OK'

export const GET_STDT_ATTRIBUTE = 'GET_STDT_ATTRIBUTE'
export const GET_STDT_ATTRIBUTE_FAILED = 'GET_STDT_ATTRIBUTE_FAILED'
export const GET_STDT_ATTRIBUTE_OK = 'GET_STDT_ATTRIBUTE_OK'

export const UPDATE_STDT_INFO = 'UPDATE_STDT_INFO'
export const UPDATE_STDT_INFO_FAILED = 'UPDATE_STDT_INFO_FAILED'
export const UPDATE_STDT_INFO_OK = 'UPDATE_STDT_INFO_OK'

export const GET_STDT_SMR = 'GET_STDT_SMR'
export const GET_STDT_SMR_FAILED = 'GET_STDT_SMR_FAILED'
export const GET_STDT_SMR_OK = 'GET_STDT_SMR_OK'

export const GET_STDT_SMR_CT = 'GET_STDT_SMR_CT'
export const GET_STDT_SMR_CT_FAILED = 'GET_STDT_SMR_CT_FAILED'
export const GET_STDT_SMR_CT_OK = 'GET_STDT_SMR_CT_OK'

export const GET_STDT_CRT_CLS = 'GET_STDT_CRT_CLS'
export const GET_STDT_CRT_CLS_FAILED = 'GET_STDT_CRT_CLS_FAILED'
export const GET_STDT_CRT_CLS_OK = 'GET_STDT_CRT_CLS_OK'

export const GET_STDT_HST_CLS = 'GET_STDT_HST_CLS'
export const GET_STDT_HST_CLS_FAILED = 'GET_STDT_HST_CLS_FAILED'
export const GET_STDT_HST_CLS_OK = 'GET_STDT_HST_CLS_OK'

export const GET_STDT_CHC_RCD = 'GET_STDT_CHC_RCD'
export const GET_STDT_CHC_RCD_FAILED = 'GET_STDT_CHC_RCD_FAILED'
export const GET_STDT_CHC_RCD_OK = 'GET_STDT_CHC_RCD_OK'

export const GET_STDT_LOG = 'GET_STDT_LOG'
export const GET_STDT_LOG_FAILED = 'GET_STDT_LOG_FAILED'
export const GET_STDT_LOG_OK = 'GET_STDT_LOG_OK'

export const UPDATE_TRADE = 'UPDATE_TRADE'
export const UPDATE_TRADE_FAILED = 'UPDATE_TRADE_FAILED'
export const UPDATE_TRADE_OK = 'UPDATE_TRADE_OK'

// victor add for updating and getting trade of the class student

export const UPDATE_TRADE2 = 'UPDATE_TRADE2'
export const UPDATE_TRADE2_FAILED = 'UPDATE_TRADE2_FAILED'
export const UPDATE_TRADE2_OK = 'UPDATE_TRADE2_OK'

export const GET_TRADE = 'GET_TRADE'
export const GET_TRADE_FAILED = 'GET_TRADE_FAILED'
export const GET_TRADE_OK = 'GET_TRADE_OK'
// victor add for get history trade of the student
export const GET_STDT_HST_TRADE = 'GET_STDT_HST_TRADE'
export const GET_STDT_HST_TRADE_FAILED = 'GET_STDT_HST_TRADE_FAILED'
export const GET_STDT_HST_TRADE_OK = 'GET_STDT_HST_TRADE_OK'

export const UPDATE_SCH_STDT_STT = 'UPDATE_SCH_STDT_STT'
export const UPDATE_SCH_STDT_STT_FAILED = 'UPDATE_SCH_STDT_STT_FAILED'
export const UPDATE_SCH_STDT_STT_OK = 'UPDATE_SCH_STDT_STT_OK'

// Announcement
export const OPERATE_ANN = 'OPERATE_ANN'
export const OPERATE_ANN_FAILED = 'OPERATE_ANN_FAILED'
export const OPERATE_ANN_OK = 'OPERATE_ANN_OK'

export const ADD_ANN = 'ADD_ANN'
export const ADD_ANN_FAILED = 'ADD_ANN_FAILED'
export const ADD_ANN_OK = 'ADD_ANN_OK'

export const GET_ANN_LIST = 'GET_ANN_LIST'
export const GET_ANN_LIST_FAILED = 'GET_ANN_LIST_FAILED'
export const GET_ANN_LIST_OK = 'GET_ANN_LIST_OK'

// class
export const ADD_CLS = 'ADD_CLS'
export const ADD_CLS_FAILED = 'ADD_CLS_FAILED'
export const ADD_CLS_OK = 'ADD_CLS_OK'

export const GET_CLS_BY_TYPE = 'GET_CLS_BY_TYPE'
export const GET_CLS_BY_TYPE_FAILED = 'GET_CLS_BY_TYPE_FAILED'
export const GET_CLS_BY_TYPE_OK = 'GET_CLS_BY_TYPE_OK'

export const GET_CLS_CT_BY_TYPE = 'GET_CLS_CT_BY_TYPE'
export const GET_CLS_CT_BY_TYPE_FAILED = 'GET_CLS_CT_BY_TYPE_FAILED'
export const GET_CLS_CT_BY_TYPE_OK = 'GET_CLS_CT_BY_TYPE_OK'

export const GET_CLS_BY_KEY ='GET_CLS_BY_KEY'
export const GET_CLS_BY_KEY_FAILED = 'GET_CLS_BY_KEY_FAILED'
export const GET_CLS_BY_KEY_OK = 'GET_CLS_BY_KEY_OK'

export const GET_CLS_BY_ID = 'GET_CLS_BY_ID'
export const GET_CLS_BY_ID_FAILED = 'GET_CLS_BY_ID_FAILED'
export const GET_CLS_BY_ID_OK = 'GET_CLS_BY_ID_OK'

export const GET_CLS_TCH = 'GET_CLS_TCH'
export const GET_CLS_TCH_FAILED = 'GET_CLS_TCH_FAILED'
export const GET_CLS_TCH_OK = 'GET_CLS_TCH_OK'

export const GET_CLS_STDT = 'GET_CLS_STDT'
export const GET_CLS_STDT_FAILED = 'GET_CLS_STDT_FAILED'
export const GET_CLS_STDT_OK = 'GET_CLS_STDT_OK'

export const UPDATE_CLS_STDT_STT = 'UPDATE_CLS_STDT_STT'
export const UPDATE_CLS_STDT_STT_FAILED = 'UPDATE_CLS_STDT_STT_FAILED'
export const UPDATE_CLS_STDT_STT_OK = 'UPDATE_CLS_STDT_STT_OK'

export const UPDATE_CLS_TCH = 'UPDATE_CLS_TCH'
export const UPDATE_CLS_TCH_FAILED = 'UPDATE_CLS_TCH_FAILED'
export const UPDATE_CLS_TCH_OK = 'UPDATE_CLS_TCH_OK'

export const UPDATE_CLS_STDT = 'UPDATE_CLS_STDT'
export const UPDATE_CLS_STDT_FAILED = 'UPDATE_CLS_STDT_FAILED'
export const UPDATE_CLS_STDT_OK = 'UPDATE_CLS_STDT_OK'

export const UPDATE_CLS_STT = 'UPDATE_CLS_STT'
export const UPDATE_CLS_STT_FAILED = 'UPDATE_CLS_STT_FAILED'
export const UPDATE_CLS_STT_OK = 'UPDATE_CLS_STT_OK'

export const CLS_JOIN_MULTI = 'CLS_JOIN_MULTI'
export const CLS_JOIN_MULTI_FAILED = 'CLS_JOIN_MULTI_FAILED'
export const CLS_JOIN_MULTI_OK = 'CLS_JOIN_MULTI_OK'

export const UPDATE_CLS = 'UPDATE_CLS'
export const UPDATE_CLS_FAILED = 'UPDATE_CLS_FAILED'
export const UPDATE_CLS_OK = 'UPDATE_CLS_OK'

// lesson
export const ADD_CLS_LSS = 'ADD_CLS_LSS'
export const ADD_CLS_LSS_FAILED = 'ADD_CLS_LSS_FAILED'
export const ADD_CLS_LSS_OK = 'ADD_CLS_LSS_OK'

export const UPDATE_CLS_LSS = 'UPDATE_CLS_LSS'
export const UPDATE_CLS_LSS_FAILED = 'UPDATE_CLS_LSS_FAILED'
export const UPDATE_CLS_LSS_OK = 'UPDATE_CLS_LSS_OK'

export const DELETE_CLS_LSS = 'DELETE_CLS_LSS'
export const DELETE_CLS_LSS_FAILED = 'DELETE_CLS_LSS_FAILED'
export const DELETE_CLS_LSS_OK = 'DELETE_CLS_LSS_OK'

export const ADD_CLS_LSS_STDT = 'ADD_CLS_LSS_STDT'
export const ADD_CLS_LSS_STDT_FAILED = 'ADD_CLS_LSS_STDT_FAILED'
export const ADD_CLS_LSS_STDT_OK = 'ADD_CLS_LSS_STDT_OK'

export const GET_CLS_LSS_STDT = 'GET_CLS_LSS_STDT'
export const GET_CLS_LSS_STDT_FAILED = 'GET_CLS_LSS_STDT_FAILED'
export const GET_CLS_LSS_STDT_OK = 'GET_CLS_LSS_STDT_OK'

export const GET_CHC_STT = 'GET_CHC_STT'
export const GET_CHC_STT_FAILED = 'GET_CHC_STT_FAILED'
export const GET_CHC_STT_OK = 'GET_CHC_STT_OK'

export const UPDATE_STDT_CHC_STT = 'UPDATE_STDT_CHC_STT'
export const UPDATE_STDT_CHC_STT_FAILED = 'UPDATE_STDT_CHC_STT_FAILED'
export const UPDATE_STDT_CHC_STT_OK = 'UPDATE_STDT_CHC_STT_OK'

export const GET_CLS_LSS = 'GET_CLS_LSS'
export const GET_CLS_LSS_FAILED = 'GET_CLS_LSS_FAILED'
export const GET_CLS_LSS_OK = 'GET_CLS_LSS_OK'

export const UPDATE_LSS_TCH = 'UPDATE_LSS_TCH'
export const UPDATE_LSS_TCH_FAILED = 'UPDATE_LSS_TCH_FAILED'
export const UPDATE_LSS_TCH_OK = 'UPDATE_LSS_TCH_OK'

export const S_CHECK_NOTE = 'S_CHECK_NOTE'
export const S_CHECK_NOTE_FAILED = 'S_CHECK_NOTE_FAILED'
export const S_CHECK_NOTE_OK = 'S_CHECK_NOTE_OK'

export const T_CHECK_NOTE = 'T_CHECK_NOTE'
export const T_CHECK_NOTE_FAILED = 'T_CHECK_NOTE_FAILED'
export const T_CHECK_NOTE_OK = 'T_CHECK_NOTE_OK'

export const ADD_LSN_WITH_TIME = 'ADD_LSN_WITH_TIME'
export const ADD_LSN_WITH_TIME_FAILED = 'ADD_LSN_WITH_TIME_FAILED'
export const ADD_LSN_WITH_TIME_OK = 'ADD_LSN_WITH_TIME_OK'

export const UPDATE_LSN_WITH_TIME = 'UPDATE_LSN_WITH_TIME'
export const UPDATE_LSN_WITH_TIME_FAILED = 'UPDATE_LSN_WITH_TIME_FAILED'
export const UPDATE_LSN_WITH_TIME_OK = 'UPDATE_LSN_WITH_TIME_OK'

export const ADD_MULTI_LSN_WITH_TIME = 'ADD_MULTI_LSN_WITH_TIME'
export const ADD_MULTI_LSN_WITH_TIME_FAILED = 'ADD_MULTI_LSN_WITH_TIME_FAILED'
export const ADD_MULTI_LSN_WITH_TIME_OK = 'ADD_MULTI_LSN_WITH_TIME_OK'

// teacher
export const RGST_TCH = 'RGST_TCH'
export const RGST_TCH_FAILED = 'RGST_TCH_FAILED'
export const RGST_TCH_OK = 'RGST_TCH_OK'

export const UPDATE_TCH = 'UPDATE_TCH'
export const UPDATE_TCH_FAILED = 'UPDATE_TCH_FAILED'
export const UPDATE_TCH_OK = 'UPDATE_TCH_OK'
export const GET_TCH_INFO = 'GET_TCH_INFO'
export const GET_TCH_INFO_OK = 'GET_TCH_INFO_OK'
export const GET_TCH_INFO_FAILED = 'GET_TCH_INFO_FAILED'

export const GET_TCH_CHC_RCD = 'GET_TCH_CHC_RCD'
export const GET_TCH_CHC_RCD_FAILED = 'GET_TCH_CHC_RCD_FAILED'
export const GET_TCH_CHC_RCD_OK = 'GET_TCH_CHC_RCD_OK'

export const GET_TCH_STT = 'GET_TCH_STT'
export const GET_TCH_STT_FAILED = 'GET_TCH_STT_FAILED'
export const GET_TCH_STT_OK = 'GET_TCH_STT_OK'

export const T_LOG_IN = 'T_LOG_IN'
export const T_LOG_IN_FAILED = 'T_LOG_IN_FAILED'
export const T_LOG_IN_OK = 'T_LOG_IN_OK'

// classroom
export const RGST_CLSROOM = 'RGST_CLSROOM'
export const RGST_CLSROOM_FAILED = 'RGST_CLSROOM_FAILED'
export const RGST_CLSROOM_OK = 'RGST_CLSROOM_OK'

export const UPDATE_CLSROOM = 'UPDATE_CLSROOM'
export const UPDATE_CLSROOM_FAILED = 'UPDATE_CLSROOM_FAILED'
export const UPDATE_CLSROOM_OK = 'UPDATE_CLSROOM_OK'

export const GET_CLSROOM = 'GET_CLSROOM'
export const GET_CLSROOM_FAILED = 'GET_CLSROOM_FAILED'
export const GET_CLSROOM_OK = 'GET_CLSROOM_OK'

export const GET_CLSROOM_LST = 'GET_CLSROOM_LST'
export const GET_CLSROOM_LST_FAILED = 'GET_CLSROOM_LST_FAILED'
export const GET_CLSROOM_LST_OK = 'GET_CLSROOM_LST_OK'

// school
export const S_LOG_IN = 'S_LOG_IN'
export const S_LOG_IN_FAILED = 'S_LOG_IN_FAILED'
export const S_LOG_IN_OK = 'S_LOG_IN_OK'

// Billy add school group list -- Nov.28.2017
export const S_GROUP_LIST = 'S_GROUP_LIST'
export const S_GROUP_LIST_OK = 'S_GROUP_LIST_OK'
export const S_GROUP_LIST_FAILED = 'S_GROUP_LIST_FAILED'

// Billy add group list register --Nov.29.2017
export const RGST_GROUP_LIST = 'RGST_GROUP_LIST'
export const RGST_GROUP_LIST_OK = 'RGST_GROUP_LIST_OK'
export const RGST_GROUP_LIST_FAILED = 'RGST_GROUP_LIST_FAILED'

// Billy add group list register --Nov.29.2017
export const GROUP_LIST_TEACHER = 'GROUP_LIST_TEACHER'
export const GROUP_LIST_TEACHER_OK = 'GROUP_LIST_TEACHER_OK'
export const GROUP_LIST_TEACHER_FAILED = 'GROUP_LIST_TEACHER_FAILED'

// Billy add group detail -- Nov.29.2017
export const GET_GROUP_DETAIL = 'GET_GROUP_DETAIL'
export const GET_GROUP_DETAIL_OK = 'GET_GROUP_DETAIL_OK'
export const GET_GROUP_DETAIL_FAILED = 'GET_GROUP_DETAIL_FAILED'

// Billy add delete group -- Nov.30.2017
export const DELETE_GROUP = 'DELETE_GROUP'
export const DELETE_GROUP_OK = 'DELETE_GROUP_OK'
export const DELETE_GROUP_FAILED = 'DELETE_GROUP_FAILED'

// Billy add edit group detail -- Nov.30.2017
export const UPDATE_GROUP_LIST_TEACHER = 'UPDATE_GROUP_LIST_TEACHER'
export const UPDATE_GROUP_LIST_TEACHER_OK = 'UPDATE_GROUP_LIST_TEACHER_OK'
export const UPDATE_GROUP_LIST_TEACHER_FAILED = 'UPDATE_GROUP_LIST_TEACHER_FAILED'

// Billy add update teacher group groupListTeacher
export const UPDATE_GROUP_LIST = 'UPDATE_GROUP_LIST'
export const UPDATE_GROUP_LIST_OK = 'UPDATE_GROUP_LIST_OK'
export const UPDATE_GROUP_LIST_FAILED = 'UPDATE_GROUP_LIST_FAILED'

// Billy add school permission list -- Nov.29.2017
export const S_PERMISSION_LIST = 'S_PERMISSION_LIST'
export const S_PERMISSION_LIST_OK = 'S_PERMISSION_LIST_OK'
export const S_PERMISSION_LIST_FAILED = 'S_PERMISSION_LIST_FAILED'

// Billy add register school -- Nov.08.2017
export const RGST_SCHOOL = 'RGST_SCHOOL'
export const RGST_SCHOOL_FAILED = 'RGST_SCHOOL_FAILED'
export const RGST_SCHOOL_OK = 'RGST_SCHOOL_OK'

// Billy add school sign up -- Nov.07.2017
export const S_SIGN_UP = 'S_SIGN_UP'
export const S_SIGN_UP_FAILED = 'S_SIGN_UP_FAILED'
export const S_SIGN_UP_OK = 'S_SIGN_UP_OK'

export const GET_SCH_TCH_LST = 'GET_SCH_TCH_LST'
export const GET_SCH_TCH_LST_FAILED = 'GET_SCH_TCH_LST_FAILED'
export const GET_SCH_TCH_LST_OK = 'GET_SCH_TCH_LST_OK'

export const GET_SCH_STDT_LST = 'GET_SCH_STDT_LST'
export const GET_SCH_STDT_LST_FAILED = 'GET_SCH_STDT_LST_FAILED'
export const GET_SCH_STDT_LST_OK = 'GET_SCH_STDT_LST_OK'

export const GET_USER_BY_TOKEN = 'GET_USER_BY_TOKEN'
export const GET_USER_BY_TOKEN_FAILED = 'GET_USER_BY_TOKEN_FAILED'
export const GET_USER_BY_TOKEN_OK = 'GET_USER_BY_TOKEN_OK'

export const REFRESH_TOKEN = 'REFRESH_TOKEN'
export const REFRESH_TOKEN_FAILED = 'REFRESH_TOKEN_FAILED'
export const REFRESH_TOKEN_OK = 'REFRESH_TOKEN_OK'

export const CHANGE_PASSWD = 'CHANGE_PASSWD'
export const CHANGE_PASSWD_FAILED = 'CHANGE_PASSWD_FAILED'
export const CHANGE_PASSWD_OK = 'CHANGE_PASSWD_OK'

export const SEND_PHONE_VRFCTION = 'SEND_PHONE_VRFCTION'
export const SEND_PHONE_VRFCTION_FAILED = 'SEND_PHONE_VRFCTION_FAILED'
export const SEND_PHONE_VRFCTION_OK = 'SEND_PHONE_VRFCTION_OK'

export const GET_TRADE_LIST = 'GET_TRADE_LIST'
export const GET_TRADE_LIST_FAILED = 'GET_TRADE_LIST_FAILED'
export const GET_TRADE_LIST_OK = 'GET_TRADE_LIST_OK'

export const GET_TRADE_NOTE = 'GET_TRADE_NOTE'
export const GET_TRADE_NOTE_FAILED = 'GET_TRADE_NOTE_FAILED'
export const GET_TRADE_NOTE_OK = 'GET_TRADE_NOTE_OK'

export const UPDATE_TRADE_NOTE = 'UPDATE_TRADE_NOTE'
export const UPDATE_TRADE_NOTE_FAILED = 'UPDATE_TRADE_NOTE_FAILED'
export const UPDATE_TRADE_NOTE_OK = 'UPDATE_TRADE_NOTE_OK'

export const SEND_TRADE_EMAIL = 'SEND_TRADE_EMAIL'
export const SEND_TRADE_EMAIL_FAILED = 'SEND_TRADE_EMAIL_FAILED'
export const SEND_TRADE_EMAIL_OK = 'SEND_TRADE_EMAIL_OK'

export const GET_TIMETABLE = 'GET_TIMETABLE'
export const GET_TIMETABLE_FAILED = 'GET_TIMETABLE_FAILED'
export const GET_TIMETABLE_OK = 'GET_TIMETABLE_OK'

// misc
export const SBMT_OPRT_LOG = 'SBMT_OPRT_LOG'
export const SBMT_OPRT_LOG_FAILED = 'SBMT_OPRT_LOG_FAILED'
export const SBMT_OPRT_LOG_OK = 'SBMT_OPRT_LOG_OK'

export const GET_OPRT_LOG = 'GET_OPRT_LOG'
export const GET_OPRT_LOG_FAILED = 'GET_OPRT_LOG_FAILED'
export const GET_OPRT_LOG_OK = 'GET_OPRT_LOG_OK'

// Upgrade to Permium Version -- Billy Dec 06.2017
export const PAYMENT_METHOD = 'PAYMENT_METHOD'
export const PAYMENT_METHOD_OK = 'PAYMENT_METHOD_OK'
export const PAYMENT_METHOD_FAILED = 'PAYMENT_METHOD_FAILED'

export const SUBSCRIPTION = 'SUBSCRIPTION'
export const SUBSCRIPTION_OK = 'SUBSCRIPTION_OK'
export const SUBSCRIPTION_FAILED = 'SUBSCRIPTION_FAILED'

export const GET_SUBSCRIPTION = 'GET_SUBSCRIPTION'
export const GET_SUBSCRIPTION_OK = 'GET_SUBSCRIPTION_OK'
export const GET_SUBSCRIPTION_FAILED = 'GET_SUBSCRIPTION_FAILED'

export const TEACHER_CONFIRMATION = 'TEACHER_CONFIRMATION'
export const TEACHER_CONFIRMATION_OK = 'TEACHER_CONFIRMATION_OK'
export const TEACHER_CONFIRMATION_FAILED = 'TEACHER_CONFIRMATION_FAILED'

export const G_S_CURRENT_TEACHER = 'G_S_CURRENT_TEACHER'
export const G_S_CURRENT_TEACHER_OK = 'G_S_CURRENT_TEACHER_OK'
export const G_S_CURRENT_TEACHER_FAILED = 'G_S_CURRENT_TEACHER'

export const G_S_ARCHIVED_TEACHER = 'G_S_ARCHIVED_TEACHER'
export const G_S_ARCHIVED_TEACHER_OK = 'G_S_ARCHIVED_TEACHER_OK'
export const G_S_ARCHIVED_TEACHER_FAILED = 'G_S_ARCHIVED_TEACHER'

export const INVITE_TEACHER = 'INVITE_TEACHER'
export const INVITE_TEACHER_OK = 'INVITE_TEACHER_OK'
export const INVITE_TEACHER_FAILED = 'INVITE_TEACHER_FAILED'

export const DELETE_SCHOOL = 'DELETE_SCHOOL'
export const DELETE_SCHOOL_OK = 'DELETE_SCHOOL_OK'
export const DELETE_SCHOOL_FAILED = 'DELETE_SCHOOL_FAILED'

export const G_TEACHER_EXIT = 'G_TEACHER_EXIT'
export const G_TEACHER_EXIT_OK = 'G_TEACHER_EXIT_OK'
export const G_TEACHER_EXIT_FAILED = 'G_TEACHER_EXIT_FAILED'

export const M_S_ARCHIVED = 'M_S_ARCHIVED'
export const M_S_ARCHIVED_OK = 'M_S_ARCHIVED_OK'
export const M_S_ARCHIVED_FAILED = 'M_S_ARCHIVED_FAILED'

// Ryan add UI actions
export const UPDATE_HEADER_HIGHLIGHT = 'UPDATE_HEADER_HIGHLIGHT'

export const GET_MONTHLY_FINANCE ='GET_MONTHLY_FINANCE'
export const GET_MONTHLY_FINANCE_OK ='GET_MONTHLY_FINANCE_OK'
export const GET_MONTHLY_FINANCE_FAILED='GET_MONTHLY_FINANCE_FAILED'


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js